import React, { useState, useEffect, useRef } from "react";
import placeholder from "../assets/images/house-placeholder.webp";
import { Link, useLocation } from "react-router-dom";
import imgs from "./temp.json";
import constants from "../constants/constants";
import BouncingDotsLoader from "./loader.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faMagnifyingGlass,
  faX,
} from "@fortawesome/free-solid-svg-icons";
import pageSEO from "../constants/pageSEO";
import SEO from "./seo.component";
import isReactSnap from "../utils/isReactSnap";
import DEMO_LISTINGS from "../constants/demoListings";

// Function to get image from assets/images folder based on ListingKey
function getListingImage(listingKey) {
  if (!listingKey) return placeholder;
  
  try {
    // Use require.context to get all images from the images folder
    const imageContext = require.context('../assets/images', false, /\.(jpg|jpeg|png|webp)$/i);
    const imageKeys = imageContext.keys();
    
    // Find images that contain the ListingKey in their filename
    const matchingImages = imageKeys.filter(key => {
      const fileName = key.toLowerCase();
      const listingKeyLower = listingKey.toLowerCase();
      return fileName.includes(listingKeyLower);
    });
    
    if (matchingImages.length === 0) {
      return placeholder;
    }
    
    // Prioritize "main photo" images, otherwise return the first match
    const mainPhoto = matchingImages.find(key => key.toLowerCase().includes('main photo'));
    if (mainPhoto) {
      return imageContext(mainPhoto);
    }
    
    // Return the first matching image
    return imageContext(matchingImages[0]);
  } catch (error) {
    console.error('Error loading listing image:', error);
    return placeholder;
  }
}

export default function CommercialListings() {
  const { state } = useLocation();
  const seoConfig = pageSEO.commercial();

  const [request, setRequest] = useState(
    `${
      constants.ENVIRONMENT === "local"
        ? "https://query.ampre.ca/"
        : `https://${constants.DOMAIN}/api/`
    }odata/Property?$filter=contains(PropertyType, 'Commercial')&$orderby=OriginalEntryTimestamp desc,ListingKey&$top=500`
  );
  const [listings, setListings] = useState([]);
  const [media, setMedia] = useState(imgs.thumbs.value);
  const [formatted, setFormatted] = useState({});
  const [loaded, setLoaded] = useState(false);
  const loadedRef = useRef(false);
  const [searching, setSearching] = useState(state ? 2 : 0);
  const [currentPage, setCurrentPage] = useState(1);
  function getData(
    url = `${
      constants.ENVIRONMENT === "local"
        ? "https://query.ampre.ca/"
        : `https://${constants.DOMAIN}/api/`
    }odata/Property?$filter=contains(PropertyType, 'Commercial')&$orderby=OriginalEntryTimestamp desc,ListingKey&$top=500`
  ) {
    // Skip API calls during static generation
    if (isReactSnap()) {
      return Promise.resolve({ value: DEMO_LISTINGS });
    }

    var body = {
      url: url,
      needAuth: true,
      bearerToken: constants.TOKEN,
      // Accept: 'application/json',
      // Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ2ZW5kb3IvdHJyZWIvNjUyMCIsImF1ZCI6IkFtcFVzZXJzUHJkIiwicm9sZXMiOlsiQW1wVmVuZG9yIl0sImlzcyI6InByb2QuYW1wcmUuY2EiLCJleHAiOjI1MzQwMjMwMDc5OSwiaWF0IjoxNzMwMjI1OTA1LCJzdWJqZWN0VHlwZSI6InZlbmRvciIsInN1YmplY3RLZXkiOiI2NTIwIiwianRpIjoiMGYyMjk3OTY1Y2NjN2U4MSIsImN1c3RvbWVyTmFtZSI6InRycmViIn0.BMvVrtwah8swIzW38UMs6yKF-HM4QO0bZu81blYx6J4'
    };
    return new Promise(async (resolve, reject) => {
      try {
        // fetch(`${proxyUrl}https://query.ampre.ca/odata/Property?$filter=ListAgentKey eq \'${constants.AGENT_ID}\' or CoListAgentKey eq \'${constants.AGENT_ID}\'&orderby=OriginalEntryTimestamp desc,ListingKey&$top=12`, {
        // prod
        // let data = await fetch(`https://${constants.DOMAIN}/api/odata/Property(Q)$orderby=OriginalEntryTimestamp(S)desc,ListingKey(A)$top=12`)
        // dev
        let data =
          constants.ENVIRONMENT === "prod"
            ? await fetch(formatStr(url))
            : await fetch(`http://${constants.URL}/metaGet`, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                  "Content-Type": "application/json",
                },
              });
        if (data.ok) {
          let res = await data.json();
          console.log(res.value);
          // Check if we have valid data
          if (res && res.value && res.value.length > 0) {
            resolve(res);
          } else {
            // Return demo data if API returns empty result
            console.warn("API returned empty data, using demo listings");
            resolve({ value: DEMO_LISTINGS });
          }
        } else {
          // Return demo data if API call fails
          console.warn("API call failed, using demo listings");
          resolve({ value: DEMO_LISTINGS });
        }
      } catch (err) {
        // Return demo data on error
        console.warn("Error fetching listings, using demo data:", err);
        resolve({ value: DEMO_LISTINGS });
      }
    });
  }

  useEffect(() => {
    if (loaded) {
      getMedia(
        listings?.slice(
          maxListings * (currentPage - 1),
          maxListings * (currentPage - 1) + maxListings
        )
      )
        .then((d) => {
          setMedia(d.value);
          setFormatted(formatMedia(d.value));
          console.log(d.value);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [currentPage]);

  function capitalize(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
  }

  function getMedia(listings) {
    // if (!listings?.length) {
    //     return {}
    // }
    console.log(listings);
    if (constants.ENVIRONMENT === "local") {
      var temp = `https://query.ampre.ca/odata/Media?$filter=ResourceRecordKey in (`;
      for (let l of listings) {
        temp = temp + "'" + l.ListingKey + "',";
      }
      if (listings.length) {
        temp = temp.slice(0, -1);
      }
      temp =
        temp +
        ") and ImageSizeDescription eq 'Thumbnail' and PreferredPhotoYN eq true";
    } else {
      var temp = `odata/Media(Q)$filter=ResourceRecordKey(S)in(S)(`;
      for (let l of listings) {
        temp = temp + "'" + l.ListingKey + "',";
      }
      if (listings.length) {
        temp = temp.slice(0, -1);
      }
      temp =
        temp +
        ")(S)and(S)ImageSizeDescription(S)eq(S)'Thumbnail'(S)and(S)PreferredPhotoYN(S)eq(S)true";
    }
    console.log(temp);

    // for development
    var body = {
      url: temp,
      needAuth: true,
      bearerToken: constants.TOKEN,
      // Accept: 'application/json',
      // Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJ2ZW5kb3IvdHJyZWIvNjUyMCIsImF1ZCI6IkFtcFVzZXJzUHJkIiwicm9sZXMiOlsiQW1wVmVuZG9yIl0sImlzcyI6InByb2QuYW1wcmUuY2EiLCJleHAiOjI1MzQwMjMwMDc5OSwiaWF0IjoxNzMwMjI1OTA1LCJzdWJqZWN0VHlwZSI6InZlbmRvciIsInN1YmplY3RLZXkiOiI2NTIwIiwianRpIjoiMGYyMjk3OTY1Y2NjN2U4MSIsImN1c3RvbWVyTmFtZSI6InRycmViIn0.BMvVrtwah8swIzW38UMs6yKF-HM4QO0bZu81blYx6J4'
    };

    return new Promise(async (resolve, reject) => {
      try {
        let data =
          constants.ENVIRONMENT === "prod"
            ? await fetch(`https://${constants.DOMAIN}/api/${temp}`)
            : await fetch(`http://${constants.URL}/metaGet`, {
                method: "POST",
                body: JSON.stringify(body),
                headers: {
                  "Content-Type": "application/json",
                },
              });
        if (data.ok) {
          let res = await data.json();
          resolve(res);
        } else {
          console.log(data);
          reject("Failed to fetch data");
        }
      } catch (err) {
        reject(err);
      }
    });
  }

  function formatMedia(media) {
    var temp = {};

    for (let img of media) {
      if (temp[img.ResourceRecordKey]) {
        temp[img.ResourceRecordKey] = [...temp[img.ResourceRecordKey], img];
      } else {
        temp[img.ResourceRecordKey] = [img];
      }
    }
    setLoaded(true);
    console.log(temp);

    return temp;
  }

  useEffect(() => {
    if (isReactSnap()) return; // Skip fetching during react-snap
    if (!loadedRef.current) {
      loadedRef.current = true;
      getData(request)
        .then((data) => {
          // Ensure we have data, use DEMO_LISTINGS if empty
          const listingsData = data.value && data.value.length > 0 ? data.value : DEMO_LISTINGS;
          setListings(listingsData);
          listingsRef.current = listingsData;

          // Check if we're using DEMO_LISTINGS
          if (listingsData === DEMO_LISTINGS || listingsData[0]?.ListingKey?.startsWith?.("DEMO")) {
            useDemoListingsRef.current = true;
          }

          if (listingsData.length > 0) {
            getMedia(
              listingsData.slice(
                maxListings * (currentPage - 1),
                maxListings * (currentPage - 1) + maxListings
              )
            )
              .then((d) => {
                setMedia(d.value);
                setFormatted(formatMedia(d.value));
                setLoaded(true);
              })
              .catch((err) => {
                console.log(err);
                setLoaded(true);
              });
          } else {
            setLoaded(true);
          }
        })
        .catch((err) => {
          console.log(err);
          // Use demo listings when API is unavailable
          setListings(DEMO_LISTINGS);
          listingsRef.current = DEMO_LISTINGS;
          useDemoListingsRef.current = true;
          setLoaded(true);
        });

      // getMedia().then(data => {
      //     console.log(data)
      //     setMedia(data.value)

      // }).catch(err => {
      //     console.log(err);
      // })
      // var temp = {}

      // for (let img of temp1) {
      //     if (temp[img.ResourceRecordKey]) {
      //         temp[img.ResourceRecordKey] = [...temp[img.ResourceRecordKey], img]
      //     } else {
      //         temp[img.ResourceRecordKey] = [img]

      //     }
      // }
      // console.log(temp)
      // setFormatted(temp);
      // setTimeout(()=>{
      //     setLoaded(true);

      // }, 3000)
    }
  }, [request]);

  const [filter, setFilter] = useState("All");

  const [searchParams, setSearchParams] = useState({
    bedrooms: "",
    bathrooms: "",
    minPrice: "",
    maxPrice: "",
  });

  function updateSearch(key, val) {
    var temp = { ...searchParams };
    temp[key] = val;
    setSearchParams(temp);
  }

  const listingsRef = useRef([]);
  // Track whether we're currently using the local DEMO_LISTINGS data
  const useDemoListingsRef = useRef(false);

  // Check if we're using DEMO_LISTINGS
  function isUsingDemoListings() {
    if (useDemoListingsRef.current) return true;
    if (listingsRef.current === DEMO_LISTINGS) {
      useDemoListingsRef.current = true;
      return true;
    }
    if (
      listingsRef.current?.[0]?.ListingKey?.startsWith?.("DEMO") ||
      listings?.[0]?.ListingKey?.startsWith?.("DEMO")
    ) {
      useDemoListingsRef.current = true;
      return true;
    }
    return false;
  }

  // Client-side filtering for DEMO_LISTINGS (Commercial properties)
  // Note: For demo purposes, we ignore PropertyType and show all DEMO_LISTINGS
  function filterDemoListings(sourceListings, params, type, currentFilter) {
    // Start with all listings (ignore PropertyType for demo)
    let filtered = [...sourceListings];

    // Filter by Agent/Office if needed
    if (type === "Agent" || (currentFilter === "Agent" && !type)) {
      filtered = filtered.filter(
        (l) =>
          l.ListAgentKey === constants.AGENT_ID ||
          l.CoListAgentKey === constants.AGENT_ID ||
          l.ListOfficeKey === constants.OFFICE_ID
      );
    }

    // Filter by PropertySubType (stored in bedrooms param for commercial)
    if (params.bedrooms?.trim()) {
      const match = params.bedrooms.match(/contains\(PropertySubType,\s*'([^']+)'\)/);
      if (match && match[1]) {
        const subType = match[1];
        filtered = filtered.filter((l) =>
          (l.PropertySubType || "").includes(subType)
        );
      }
    }

    // Filter by BuildingAreaTotal (stored in bathrooms param for commercial)
    if (params.bathrooms?.trim()) {
      const areaStr = params.bathrooms.trim();
      if (areaStr.includes("lt 500")) {
        filtered = filtered.filter((l) => (l.BuildingAreaTotal ?? 0) < 500);
      } else if (areaStr.includes("ge 500 and BuildingAreaTotal le 1000")) {
        filtered = filtered.filter(
          (l) =>
            (l.BuildingAreaTotal ?? 0) >= 500 &&
            (l.BuildingAreaTotal ?? 0) <= 1000
        );
      } else if (areaStr.includes("ge 1000 and BuildingAreaTotal le 1500")) {
        filtered = filtered.filter(
          (l) =>
            (l.BuildingAreaTotal ?? 0) >= 1000 &&
            (l.BuildingAreaTotal ?? 0) <= 1500
        );
      } else if (areaStr.includes("ge 1500 and BuildingAreaTotal le 2000")) {
        filtered = filtered.filter(
          (l) =>
            (l.BuildingAreaTotal ?? 0) >= 1500 &&
            (l.BuildingAreaTotal ?? 0) <= 2000
        );
      } else if (areaStr.includes("ge 2000")) {
        filtered = filtered.filter((l) => (l.BuildingAreaTotal ?? 0) >= 2000);
      }
    }

    // Filter by minimum price
    if (params.minPrice?.trim()) {
      const match = params.minPrice.match(/ListPrice ge (\d+)/);
      if (match && match[1]) {
        const minVal = parseInt(match[1]);
        if (!Number.isNaN(minVal)) {
          filtered = filtered.filter((l) => (l.ListPrice ?? 0) >= minVal);
        }
      }
    }

    // Filter by maximum price
    if (params.maxPrice?.trim()) {
      const match = params.maxPrice.match(/ListPrice le (\d+)/);
      if (match && match[1]) {
        const maxVal = parseInt(match[1]);
        if (!Number.isNaN(maxVal)) {
          filtered = filtered.filter((l) => (l.ListPrice ?? 0) <= maxVal);
        }
      }
    }

    // Sort by OriginalEntryTimestamp desc, then by ListingKey
    filtered.sort((a, b) => {
      const dateA = new Date(a.OriginalEntryTimestamp || 0).getTime();
      const dateB = new Date(b.OriginalEntryTimestamp || 0).getTime();
      if (dateB !== dateA) return dateB - dateA;
      return (a.ListingKey || "").localeCompare(b.ListingKey || "");
    });

    return filtered;
  }

  function filterListings(filter) {
    if (filter === "All") {
      setListings(listingsRef.current);
    } else if (filter === "Agent") {
      setListings(
        listingsRef.current.filter(
          (l) =>
            l.ListAgentKey === constants.AGENT_ID ||
            l.CoListAgentKey === constants.AGENT_ID ||
            l.ListOfficeKey === constants.OFFICE_ID
        )
      );
    }
  }

  function runSearch(type) {
    console.log(filter, type, searchParams);

    // When using DEMO_LISTINGS, filter locally instead of calling the API
    if (isUsingDemoListings()) {
      setLoaded(false);
      setSearching(1);

      const filteredListings =
        type === "Reset"
          ? DEMO_LISTINGS  // Show all DEMO_LISTINGS for demo (ignore PropertyType)
          : filterDemoListings(DEMO_LISTINGS, searchParams, type, filter);

      setListings(filteredListings);
      listingsRef.current = filteredListings;
      useDemoListingsRef.current = true;
      setFormatted({});
      setCurrentPage(1);

      const hasParams =
        Object.entries(searchParams).filter(
          ([, v]) =>
            v && v !== "undefined" && v !== "null" && v.trim() !== ""
        ).length > 0;

      setSearching((type && !hasParams) || type === "Reset" ? 3 : 2);
      setLoaded(true);
      return;
    }

    // Original API-based search logic for non-demo data
    // var str = `https://query.ampre.ca/odata/Property?$filter=${filter === 'Agent' ? `ListAgentKey eq \'${constants.AGENT_ID}\' or CoListAgentKey eq \'${constants.AGENT_ID}\' or ListOfficeKey eq \'${constants.OFFICE_ID}\'` : ''}${Object.entries(searchParams).filter(([k,v],i)=>!!v)?.length ? ' and ' : ''}`
    var str = `https://query.ampre.ca/odata/Property?$filter=${
      type === "Agent" || (filter === "Agent" && !type)
        ? `(ListAgentKey eq \'${constants.AGENT_ID}\' or CoListAgentKey eq \'${constants.AGENT_ID}\' or ListOfficeKey eq \'${constants.OFFICE_ID}\') and `
        : ""
    }contains(PropertyType, 'Commercial') and `;
    if (type !== "Reset") {
      for (let val of Object.values(searchParams)) {
        if (val) {
          str = str + val + " and ";
        }
      }
    }

    if (
      type !== "Reset" &&
      (Object.entries(searchParams).filter(([k, v], i) => !!v)?.length ||
        type === "Agent" ||
        (filter === "Agent" && !type))
    ) {
      str = str.slice(0, -5);
      str = str + "&$top=10000";
    } else {
      str = str.slice(0, -9);
      str = str + "?$orderby=OriginalEntryTimestamp desc,ListingKey&$top=500";
    }

    console.log(str);

    getData(str)
      .then((data) => {
        // Check if API returned empty data, use DEMO_LISTINGS and apply client-side filtering
        const apiHasData = data.value && data.value.length > 0;
        let listingsData;
        
        if (!apiHasData) {
          // API returned empty, use DEMO_LISTINGS and apply client-side filtering
          useDemoListingsRef.current = true;
          listingsData = type === "Reset"
            ? DEMO_LISTINGS  // Show all DEMO_LISTINGS for demo (ignore PropertyType)
            : filterDemoListings(DEMO_LISTINGS, searchParams, type, filter);
        } else {
          listingsData = data.value;
          // Check if we're using DEMO_LISTINGS
          if (listingsData === DEMO_LISTINGS || listingsData[0]?.ListingKey?.startsWith?.("DEMO")) {
            useDemoListingsRef.current = true;
          }
        }
        
        setListings(listingsData);
        listingsRef.current = listingsData;
        
        if (listingsData.length > 0) {
          getMedia(
            listingsData.slice(
              maxListings * (currentPage - 1),
              maxListings * (currentPage - 1) + maxListings
            )
          )
            .then((d) => {
              console.log(d.value);
              setMedia(d.value);
              setFormatted(formatMedia(d.value));
              setSearching(
                (type &&
                  !Object.entries(searchParams).filter(([k, v], i) => !!v)
                    ?.length) ||
                  type === "Reset"
                  ? 3
                  : 2
              );

              setLoaded(true);
            })
            .catch((err) => {
              console.log(err);
              setLoaded(true);
            });
        } else {
          setLoaded(true);
          // Set searching state even when no listings
          const hasParams =
            Object.entries(searchParams).filter(
              ([, v]) =>
                v && v !== "undefined" && v !== "null" && v.trim() !== ""
            ).length > 0;
          setSearching((type && !hasParams) || type === "Reset" ? 3 : 2);
        }
      })
      .catch((err) => {
        console.log(err);
        // Use demo listings when API is unavailable and apply client-side filtering
        useDemoListingsRef.current = true;
        const filteredListings = type === "Reset"
          ? DEMO_LISTINGS  // Show all DEMO_LISTINGS for demo (ignore PropertyType)
          : filterDemoListings(DEMO_LISTINGS, searchParams, type, filter);
        setListings(filteredListings);
        listingsRef.current = filteredListings;
        
        const hasParams =
          Object.entries(searchParams).filter(
            ([, v]) =>
              v && v !== "undefined" && v !== "null" && v.trim() !== ""
          ).length > 0;
        setSearching((type && !hasParams) || type === "Reset" ? 3 : 2);
        setLoaded(true);
      });
  }

  function clearSearch() {
    setSearching(0);
    setSearchParams({});
    setLoaded(false);
  }

  function formatStr(str) {
    const result = str
      .replaceAll(" ", "(S)")
      .replaceAll("&", "(A)")
      .replaceAll("?", "(Q)");

    return result;
  }

  function numberRange(end) {
    return new Array(end).fill().map((d, i) => i + 1);
  }

  const maxPages = 5;
  const maxListings = 20;
  function getStart() {
    // get starting index of pagination numbers such that we display the same number of pages even if
    // current page is at start or end and current page is always in middle of slice
    return Math.max(
      0,
      Math.min(
        currentPage - Math.ceil(maxPages / 2),
        Math.ceil(listings?.length / maxListings) - maxPages
      )
    );
  }

  // Function to get listing data from DEMO_LISTINGS by ListingKey
  function getListingFromDemo(listingKey) {
    return DEMO_LISTINGS.find(listing => listing.ListingKey === listingKey) || null;
  }

  // Function to merge listing data with DEMO_LISTINGS data
  function getEnhancedListing(prop) {
    const demoListing = getListingFromDemo(prop.ListingKey);
    if (demoListing) {
      // Merge demo listing data with prop data, demo data takes precedence
      return { ...prop, ...demoListing };
    }
    return prop;
  }

  return (
    <>
      <SEO {...seoConfig} />
      <div className="max-w-[1100px] mx-auto px-7 mb-10 pt-[100px] min-h-[35vh]">
        {!searching || searching === 3 || searching === 4 ? (
          <>
            <div className=" w-full bg-logo-main rounded-md py-4 px-8 mt-10">
              <h1 className="text-2xl text-black libre my-4">
                SEARCH COMMERCIAL
              </h1>
              <div className="flex flex-wrap gap-x-10 ">
                <div className="form-item max-w-36">
                  <label
                    style={{ color: "rgb(71, 71, 71)" }}
                    className="form-label "
                  >
                    Type
                  </label>
                  <select
                    className="form-input "
                    onChange={(e) => updateSearch("bedrooms", e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="contains(PropertySubType, 'Office')">
                      Office
                    </option>
                    <option value="contains(PropertySubType, 'Retail')">
                      Retail
                    </option>
                    <option value="contains(PropertySubType, 'Investment')">
                      Investment
                    </option>
                    <option value="contains(PropertySubType, 'Industrial')">
                      Industrial
                    </option>
                  </select>
                </div>
                <div className="form-item max-w-36">
                  <label
                    style={{ color: "rgb(71, 71, 71)" }}
                    className="form-label"
                  >
                    Square Footage
                  </label>
                  <select
                    className="form-input "
                    onChange={(e) => updateSearch("bathrooms", e.target.value)}
                  >
                    <option value="">Select</option>
                    <option value="BuildingAreaTotal lt 500">Under 500</option>
                    <option value="BuildingAreaTotal ge 500 and BuildingAreaTotal le 1000">
                      500-1000
                    </option>
                    <option value="BuildingAreaTotal ge 1000 and BuildingAreaTotal le 1500">
                      1000-1500
                    </option>
                    <option value="BuildingAreaTotal ge 1500 and BuildingAreaTotal le 2000">
                      1500-2000
                    </option>
                    <option value="BuildingAreaTotal ge 2000">2000+</option>
                  </select>
                </div>
                <div className="form-item max-w-36">
                  <label
                    style={{ color: "rgb(71, 71, 71)" }}
                    className="form-label"
                  >
                    Minimum Price
                  </label>
                  <input
                    className="form-input max-h-[31px]"
                    placeholder="Min"
                    onChange={(e) =>
                      updateSearch(
                        "minPrice",
                        `ListPrice ge ${e.target.value.replace(/\D/g, "")}`
                      )
                    }
                  ></input>
                </div>
                <div className="form-item max-w-36">
                  <label
                    style={{ color: "rgb(71, 71, 71)" }}
                    className="form-label"
                  >
                    Maximum Price
                  </label>
                  <input
                    className="form-input max-h-[31px]"
                    placeholder="Max"
                    onChange={(e) =>
                      updateSearch(
                        "maxPrice",
                        `ListPrice le ${e.target.value.replace(/\D/g, "")}`
                      )
                    }
                  ></input>
                </div>
              </div>
              {/* <btn onClick={() => { if (Object.entries(searchParams).filter(([k,v],i)=>!!v)?.length) { runSearch(); setSearching(1) }}} className="btn-rounded my-3 inline-block">SEARCH</btn> */}
              <btn
                onClick={() => {
                  if (
                    Object.entries(searchParams).filter(([k, v], i) => !!v)
                      ?.length
                  ) {
                    runSearch();
                  }
                }}
                className="btn-rounded my-3 inline-block"
              >
                SEARCH
              </btn>
            </div>
            <div className="flex justify-between items-end gap-x-10 flex-wrap">
              <h1 className="text-4xl text-black py-8  libre mt-6">
                Recent Listings
              </h1>
              <div className="flex-auto max-w-36 mb-8">
                <label
                  style={{ color: "rgb(71, 71, 71)" }}
                  className="form-label"
                >
                  Show:
                </label>
                {/* <select className="form-input" onChange={(e) => { setLoaded(false); setFilter(e.target.value); setRequest(e.target.value === 'Agent' ? `${constants.ENVIRONMENT === 'local' ? 'https://query.ampre.ca/' : `https://${constants.DOMAIN}/api/`}odata/Property?$filter=ListAgentKey eq \'${constants.AGENT_ID}\' or CoListAgentKey eq \'${constants.AGENT_ID}\' or ListOfficeKey eq \'${constants.OFFICE_ID}\'&orderby=OriginalEntryTimestamp desc,ListingKey&$top=1000` : `${constants.ENVIRONMENT === 'local' ? 'https://query.ampre.ca/' : `https://${constants.DOMAIN}/api/`}odata/Property?$orderby=OriginalEntryTimestamp desc,ListingKey&$top=500`) }} > */}
                <select
                  className="form-input"
                  value={filter}
                  onChange={(e) => {
                    setFilter(e.target.value);
                    setSearching(4);
                    runSearch(e.target.value);
                  }}
                >
                  <option value={"All"}>All Listings</option>
                  <option value={"Agent"}>Office Listings</option>
                  {/* <option value={`${constants.ENVIRONMENT === 'local' ? 'https://query.ampre.ca/' : `https://${constants.DOMAIN}/api/`}odata/Property?$top=1000`}>My Listings</option> */}
                </select>
              </div>
            </div>
          </>
        ) : null}

        {/* <div className={`grid ${listings?.length > 3 ? 'listing-grid' : 'listing-grid-min'} gap-9 min-h-[20vh] `}>
                            {listings.map((prop) =>
                                <Link className="w-full h-full " to={`/listing/${prop.ListingKey}`}>
                                    <div className="relative w-full aspect-[5/3] sm:aspect-[4/3] overflow-hidden">
                                        <img className="w-full h-full object-cover" src={formatted[prop.ListingKey]?.find((img) => img.Order === 0)?.MediaURL ?? formatted[prop.ListingKey]?.[0]?.MediaURL ?? placeholder} />
                                        <div className="px-2 py-1 bg-logo-second absolute bottom-0 w-full">
                                            <span className=" text-white text-sm  font-semibold">{prop.CrossStreet}</span>
                                        </div>
                                    </div>
                           
                                </Link>

                            )}

                        </div>
                    } */}

        {searching === 1 || searching === 2 ? (
          <>
            <div className="flex flex-wrap gap-x-10 bg-logo-main rounded-md pt-3 px-8 mt-10">
              <div className="form-item max-w-36">
                <label
                  style={{ color: "rgb(71, 71, 71)" }}
                  className="form-label "
                >
                  Type
                </label>
                <select
                  className="form-input min-w-[144px]"
                  value={searchParams.bedrooms}
                  onChange={(e) => updateSearch("bedrooms", e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="contains(PropertySubType, 'Office')">
                    Office
                  </option>
                  <option value="contains(PropertySubType, 'Retail')">
                    Retail
                  </option>
                  <option value="contains(PropertySubType, 'Investment')">
                    Investment
                  </option>
                  <option value="contains(PropertySubType, 'Industrial')">
                    Industrial
                  </option>
                </select>
              </div>
              <div className="form-item max-w-36">
                <label
                  style={{ color: "rgb(71, 71, 71)" }}
                  className="form-label"
                >
                  Square Footage
                </label>
                <select
                  className="form-input min-w-[144px]"
                  value={searchParams.bathrooms}
                  onChange={(e) => updateSearch("bathrooms", e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="BuildingAreaTotal lt 500">Under 500</option>
                  <option value="BuildingAreaTotal ge 500 and BuildingAreaTotal le 1000">
                    500-1000
                  </option>
                  <option value="BuildingAreaTotal ge 1000 and BuildingAreaTotal le 1500">
                    1000-1500
                  </option>
                  <option value="BuildingAreaTotal ge 1500 and BuildingAreaTotal le 2000">
                    1500-2000
                  </option>
                  <option value="BuildingAreaTotal ge 2000">2000+</option>
                </select>
              </div>
              <div className="form-item max-w-36">
                <label
                  style={{ color: "rgb(71, 71, 71)" }}
                  className="form-label"
                >
                  Min. Price
                </label>
                <input
                  className="form-input max-h-[31px]"
                  placeholder="Min"
                  defaultValue={searchParams.minPrice?.replace(/\D/g, "")}
                  onChange={(e) =>
                    updateSearch(
                      "minPrice",
                      `ListPrice ge ${e.target.value.replace(/\D/g, "")}`
                    )
                  }
                ></input>
              </div>
              <div className="form-item max-w-36">
                <label
                  style={{ color: "rgb(71, 71, 71)" }}
                  className="form-label"
                >
                  Max. Price
                </label>
                <input
                  className="form-input max-h-[31px]"
                  placeholder="Max"
                  defaultValue={searchParams.maxPrice?.replace(/\D/g, "")}
                  onChange={(e) =>
                    updateSearch(
                      "maxPrice",
                      `ListPrice le ${e.target.value.replace(/\D/g, "")}`
                    )
                  }
                ></input>
              </div>
              {/* <btn onClick={() => {  if (Object.entries(searchParams).filter(([k,v],i)=>!!v)?.length) { runSearch(); setSearching(1) } }} className="btn-rounded my-3 inline-block self-center justify-self-end">SEARCH</btn> */}
              <btn
                onClick={() => {
                  runSearch();
                }}
                className="btn-rounded my-3 inline-block self-center justify-self-end"
              >
                SEARCH
              </btn>
              <btn
                className="clear-btn self-center"
                onClick={() => {
                  setSearching(4);
                  setSearchParams({});
                  runSearch("Reset");
                }}
              >
                <FontAwesomeIcon className="fa-sm mr-2" icon={faX} />
                Clear
              </btn>
            </div>
            <div className="flex justify-between items-end gap-x-10 flex-wrap">
              <h1 className="text-4xl text-black py-8  libre mt-6">{`Results ${
                state ? `For '${state}'` : ""
              }`}</h1>
              <div className="flex-auto max-w-36 mb-8">
                <label
                  style={{ color: "rgb(71, 71, 71)" }}
                  className="form-label"
                >
                  Show:
                </label>
                <select
                  value={filter}
                  className="form-input"
                  onChange={(e) => {
                    setSearching(1);
                    runSearch(e.target.value);
                    setFilter(e.target.value);
                  }}
                >
                  <option value={"All"}>All Listings</option>
                  <option value={"Agent"}>Office Listings</option>
                  {/* <option value={`${constants.ENVIRONMENT === 'local' ? 'https://query.ampre.ca/' : `https://${constants.DOMAIN}/api/`}odata/Property?$top=1000`}>My Listings</option> */}
                </select>
              </div>
            </div>{" "}
          </>
        ) : null}

        {!loaded || searching === 1 || searching == 4 ? (
          <div className="mt-32 min-h-[20vh]">
            <BouncingDotsLoader />
          </div>
        ) : null}
        {!listings?.length && loaded ? (
          <h3 className="font-semibold text-align-center mt-12">
            <FontAwesomeIcon icon={faMagnifyingGlass} className="mr-2" /> No
            properties to show
          </h3>
        ) : null}

        {searching === 2 || searching === 3 || (searching === 0 && loaded) ? (
          <>
            <div className="grid listing-grid gap-9 min-h-[35vh] ">
              {listings
                ?.slice(
                  maxListings * (currentPage - 1),
                  maxListings * (currentPage - 1) + maxListings
                )
                ?.map((prop) => {
                  // Get enhanced listing data from DEMO_LISTINGS by ListingKey
                  const enhancedProp = getEnhancedListing(prop);
                  return (
                    <Link
                      key={enhancedProp.ListingKey}
                      className="w-full h-full"
                      to={`/listing/${enhancedProp.ListingKey}`}
                    >
                      <div className="relative w-full aspect-[5/3] sm:aspect-[4/3] overflow-hidden">
                        <img
                          className="w-full h-full object-cover"
                          src={getListingImage(enhancedProp.ListingKey)}
                        />
                        <div className="px-2 py-1 bg-logo-third absolute bottom-0 w-full max-h-[56px]">
                          <span className=" text-white text-sm  font-semibold">
                            {enhancedProp.CityRegion ?? enhancedProp.CrossStreet}
                          </span>
                        </div>
                      </div>
                    </Link>
                  );
                })}
            </div>
          </>
        ) : null}

        {listings?.length > maxListings &&
        (searching === 2 ||
          ((searching === 0 || searching === 3) && loaded)) ? (
          <>
            <div
              style={{ gridTemplateColumns: "1fr auto 1fr" }}
              className="mx-auto w-fit mt-8 grid grid-cols-[1fr auto 1fr] items-center gap-x-3"
            >
              {currentPage > 1 ? (
                <FontAwesomeIcon
                  icon={faAngleLeft}
                  className="cursor-pointer text-logo-second fa-lg"
                  onClick={() => setCurrentPage(currentPage - 1)}
                />
              ) : (
                <div />
              )}
              <div className="flex gap-2">
                {numberRange(Math.ceil(listings?.length / maxListings))
                  .slice(getStart(), getStart() + maxPages)
                  .map((num) => (
                    <div
                      key={num}
                      onClick={() => setCurrentPage(num)}
                      className={`rounded-full w-9 h-9 flex items-center justify-center cursor-pointer text-center ${
                        num === currentPage
                          ? "text-white bg-logo-second"
                          : "text-logo-second"
                      }`}
                    >
                      <span className={`font-bold text-lg `}>{num}</span>
                    </div>
                  ))}
              </div>
              {currentPage !== Math.ceil(listings?.length / maxListings) ? (
                <FontAwesomeIcon
                  icon={faAngleRight}
                  className="cursor-pointer text-logo-second fa-lg"
                  onClick={() => setCurrentPage(currentPage + 1)}
                />
              ) : (
                <div />
              )}
            </div>
            <div className="mx-auto w-fit mt-3 font-semibold text-logo-second">
              <span>
                {currentPage * maxListings - maxListings + 1} to{" "}
                {Math.min(currentPage * maxListings, listings?.length)} of{" "}
                {listings?.length} properties
              </span>
            </div>
          </>
        ) : null}
      </div>
    </>
  );
}
